import { Injectable } from '@angular/core';
import { IDeviceInformation, IDeviceNode } from '@caslink/device-client/ng-app/shared/models/device';
import { Observable } from 'rxjs';
import { DevicesHttpService } from '../../common/services/devices-http.service';

@Injectable({
    providedIn: 'root'
})
export class ControlSummaryService {

    constructor(private httpService: DevicesHttpService) {
    }

    public getControlSummary(hardwareItemId: number): Observable<IDeviceNode> {
        return this.httpService.get<IDeviceNode>(`hardware/${hardwareItemId}/summary`);
    }

    public updateControlSummary(hardwareItemId: number, deviceInfo: IDeviceInformation): Observable<any> {
        return this.httpService
            .put(`hardware/${hardwareItemId}/summary`, deviceInfo.$deviceHierarchy);
    }
}
